<template id="404">
    <div>
        <div class="alert-dialog-mask"></div>
        <div class="alert-dialog">
            <div class="alert-dialog-container">
                <div class="alert-dialog-content">
                    {{text.notFound}}}
                </div>

                <div class="alert-dialog-footer">
                    <button @click="goHome()" class="alert-dialog-button alert-dialog-button--primal">{{text.ok}}}</button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import usedText from "../util/languageText";

    export default {
        data: () => ({
            text:usedText
        }),
        methods: {
            goHome() {
                this.$router.push({path: '/'});
            }
        }
    };
</script>
